import DropdownCommon, {
  DropdownItemStyled,
} from 'components/common/DropdownCommon';
import { Fade } from 'helpers/animation';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import React, { useState } from 'react';
import styled from 'styled-components';

const CustomNotificationActionDropdown = ({
  dropdownMenuStyles = {},
  onReadAll,
  onClearAll,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const [isShowDropdown, setShowDropdown] = useState(false);

  const handleDropdownOnToggle = () => {
    setShowDropdown(!isShowDropdown);
  };

  const renderDropdownMenuChildren = () => (
    <>
      <DropdownItemStyled
        key={1}
        eventKey={0}
        onClick={onReadAll}
        style={{
          borderRadius: '8px',
        }}
      >
        {t('label_read_all')}
      </DropdownItemStyled>
      <DropdownItemStyled
        key={2}
        eventKey={1}
        onClick={onClearAll}
        style={{
          borderRadius: '8px',
        }}
      >
        {t('label_clear_all')}
      </DropdownItemStyled>
    </>
  );

  const getStyleDropdown = () => {
    const common = {
      border: '1px solid var(--ds-c-sky)',
      minHeight: '24px',
    };
    if (!isDesktop)
      return {
        ...common,
      };
    return {
      ...common,
    };
  };
  const getStyleDropdownToggle = () => {
    const common = {
      textTransform: 'uppercase',
      color: 'var(--ds-c-sky)!important',
      fontWeight: 600,
      minHeight: '34px',
      padding: '0px',
      paddingRight: '32px',
      paddingLeft: '10px',
      svgFilter: 'var(--ds-f-c-blue-sky)',
    };
    if (!isDesktop)
      return {
        ...common,
      };
    return {
      ...common,
    };
  };
  const getStyleDropdownMenu = () => {
    const common = { borderRadius: '8px', transform: 'translate(-47px, 35px)' };
    if (!isDesktop)
      return {
        ...common,
      };
    return {
      ...common,
    };
  };

  return (
    <>
      <ActionDropdownStyled $dropdownMenuStyles={dropdownMenuStyles}>
        <DropdownCommon
          value={t('label_actions')}
          isShowDropdown={isShowDropdown}
          onToggle={handleDropdownOnToggle}
          renderDropdownMenuChildren={renderDropdownMenuChildren}
          styleDropdown={getStyleDropdown()}
          styleDropdownToggle={getStyleDropdownToggle()}
          styleDropdownMenu={getStyleDropdownMenu()}
        />
      </ActionDropdownStyled>
    </>
  );
};

const ActionDropdownStyled = styled.div`
  display: flex;
  align-items: center;
  ${Fade};
`;

export default CustomNotificationActionDropdown;
